// Utilidad para manejar notificaciones del sistema
export const solicitarPermisoNotificaciones = () => {
  if ("Notification" in window && Notification.permission === "default") {
    Notification.requestPermission();
  }
};

// Reproducir sonido de notificación
export const reproducirSonido = () => {
  try {
    // Intentar con diferentes formatos (mp3, wav, ogg)
    // El navegador usará el primero que encuentre/soporte
    const audio = new Audio('/notification.wav'); // Puedes cambiar a .mp3 o .ogg
    audio.volume = 0.5; // Volumen al 50%
    audio.play().catch(err => console.log("No se pudo reproducir el sonido:", err));
  } catch (error) {
    console.log("Error al reproducir sonido:", error);
  }
};

// Mostrar notificación del sistema
export const mostrarNotificacion = (titulo, mensaje, icono = "/digera.png") => {
  if ("Notification" in window) {
    if (Notification.permission === "granted") {
      new Notification(titulo, {
        body: mensaje,
        icon: icono,
        badge: icono,
        tag: 'inventario-notification', // Evita duplicados
        requireInteraction: false, // Se cierra automáticamente
      });
    } else if (Notification.permission === "default") {
      Notification.requestPermission().then(permission => {
        if (permission === "granted") {
          new Notification(titulo, {
            body: mensaje,
            icon: icono,
          });
        }
      });
    }
  }
};

// Notificación visual en la app (alternativa si no dan permiso)
export const mostrarNotificacionApp = (mensaje, tipo = "info") => {
  // Esta función puede usarse para mostrar un banner en la app
  // Por ahora solo console.log, pero puedes integrar un toast/banner
  console.log(`[${tipo.toUpperCase()}] ${mensaje}`);
};